export default __webpack_public_path__ + "static/media/man.8f4f48a9.svg";